/**
 * *****************
 * HEADER STICKY JS
 * *****************
 */

/**
 * Variables
 *
 * @type {string}
 */
var stickyClass = 'header_sticky';
var gapScroll = 1;

/**
 * Init
 */
document.addEventListener('DOMContentLoaded', function() {
    window.addEventListener('scroll', stickyStart, true);
});

/**
 * Function stickyStart
 *
 * Check if the scrolling has started and apply the class to the header
 */
function stickyStart() {
    if(window.pageYOffset > gapScroll) {
        document.querySelector('[data-js="header"]').classList.add(stickyClass);

        window.removeEventListener('scroll', stickyStart, true);
        window.addEventListener('scroll', stickyStop, true);
    }
}

/**
 * Function stickyStop
 *
 * Check if the scrolling has stopped and remove the class to the header
 */
function stickyStop() {
    if(window.pageYOffset <= gapScroll) {
        document.querySelector('[data-js="header"]').classList.remove(stickyClass);

        window.removeEventListener('scroll', stickyStop, true);
        window.addEventListener('scroll', stickyStart, true);
    }
}